import { createTheme } from '@material-ui/core/styles/index';

export const customTheme = createTheme({
	typography: {
		fontFamily: [
			'Jost',
			'Arial',
			'sans-serif',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'Oxygen',
			'Ubuntu',
			'Cantarell',
			'"Fira Sans"',
			'"Droid Sans"',
			'"Helvetica Neue"',
		].join(','),
		h1: {
			fontSize: '2em'
		},
		h2: {
			fontSize: '1.5em'
		},
		h3: {
			fontSize: '1.17em'
		},		
		h4: {
			fontSize: '1em'
		},
		h5: {
			fontSize: '0.83em'
		},		
		h5: {
			fontSize: '0.67em'
		}		
	},
	palette: {
		primary: {
			light: '#1e2a4c',
			main: '#1d2a59',
			contrastText: '#fff'
		},
		secondary: {
			light: '#C5D6D8',
			main: '#bebebe',
			dark: '#60695C',
			contrastText: '#000'
		},
		action: {
			active: '#000',
			hover: '#f2f3f5',
			selected: '#f2f3f5',
			disabled: '#f2f3f5',
			disabledBackground: '#60695C'
		}
	},
	overrides: {
		MuiAppBar: {
			colorPrimary: {
				color: '#1e2a4c'
			}
		},
		MuiIconButton: {
			root: {
				color: '#1e2a4c'
			}
		},
		MuiSvgIcon: {
			root: {
				fill: '#787775'
			}
		},
		MuiCardHeader: {
			subheader: {
				color: '#000'
			}
		},
		MuiAlert: {
			filledError: {
				color: '#58151c',
				backgroundColor: '#f1aeb5'
			}
		},
		MuiFormHelperText: {
			root: {
				"&.MuiFormHelperText-root.Mui-error": {
					color: '#a32d24'
				}
			}
		},		
		MuiInputBase: {
			root: {
				"&.MuiInput-underline.Mui-error:after": {
					borderBottomColor: '#a32d24'
				}
			}
		}		
	}
});
